import useAgentData from '~/client/hooks/useAgentData';
import useTournaments from '../../hooks/useTournaments/useTournaments';
import TournamentEmptyState from '../../modules/TournamentLists/TournamentEmptyState';
import TournamentCard from '../../shared/TournamentCard';
import TournamentCarousel from '../TournamentCarousel';

type Props = {
  status?: TournamentStatus;
  onlyMine?: boolean;
  first?: number;
  page?: 'home' | 'list' | 'details';
};

const TournamentSection: LazyFC<Props> = ({ status, onlyMine, first }) => {
  const { tournaments, totalCount, loading } = useTournaments({
    first,
    status,
    onlyMine,
  });

  const { isMobile } = useAgentData();

  if (onlyMine && !totalCount) {
    return null;
  }

  if (!loading && !totalCount) {
    return <TournamentEmptyState status={status} onlyMine={onlyMine} />;
  }

  const items =
    tournaments?.map(({ node }) => (
      <TournamentCard
        device={isMobile ? 'mobile' : 'desktop'}
        key={node?.id}
        tournament={node}
        page="list"
      />
    )) ?? [];

  return (
    <TournamentCarousel
      status={status}
      totalCount={totalCount}
      items={items}
      placeholder={{ enabled: loading }}
      onlyMine={onlyMine}
      reelClassName="gap-4"
    />
  );
};

export default TournamentSection;
